// @flow
import Axios from 'axios';

const serverUrl = process.env.REACT_APP_SERVER_URL || '';

const axios = Axios.create({
  baseURL: serverUrl
});

const setAccessToken = (accessToken: string) => {
  localStorage.setItem('ocot_access_token', accessToken);
};

const clearAccessToken = () => {
  localStorage.removeItem('ocot_access_token');
};

axios.interceptors.request.use(async (req) => {
  const token = localStorage.getItem('ocot_access_token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

export default axios;
export {
  setAccessToken,
  clearAccessToken
};
